// eslint-disable-next-line no-undef
export const debug = process.env.DEBUG
